export enum ActivityGroupType {
  voice_builder = 'voice_builder',
  physical = 'physical',
  voice_class = 'voice_class',
  weekly_challenge = 'weekly_challenge',
}
